import TmngVersion from 'tm:tmng_version_hash';
import InBackend from 'tm:backend';
import WebshopInfo from 'tm:frontend';
import Organizer from 'tm:organizer_info';


export function __tmcache(key) {
    if (!window.sessionStorage)
        return null;
    
    const cacheKey = `tm-cache.ajax.${key}`;
    const result = window.sessionStorage.getItem(cacheKey);
    if (!result) return null;
    const parsedResult = JSON.parse(result);
    if (parsedResult.version !== TmngVersion) {
        window.sessionStorage.removeItem(cacheKey);
        return null;
    }
    return parsedResult.value;
}

__tmcache.push = function __tmcache__push(key, value) {
    if (!window.sessionStorage) return;
    window.sessionStorage.setItem(`tm-cache.ajax.${key}`, JSON.stringify({value: value, version: TmngVersion}));
}

let _batchRequests = null;
async function performRequest(data) {
    if (_batchRequests === null) {
        _batchRequests = [];
        setTimeout(() => {
            (async () => {
                const currentRequests = _batchRequests;
                _batchRequests = null;
                const { default: client } = await import("@/utils/http");

                const queries = currentRequests.map(({data}) => data);
                let results;
                try {
                    results = (await client.post(
                        '/api/path/resolve', 
                        {__batch_resolve: queries}
                    )).data;
                } catch (e) {
                    currentRequests.forEach(({rj}) => rj(e));
                    throw e;
                }

                results.forEach((url, i) => currentRequests[i].rs(url));
            })().catch(window.reportError);
        }, 1);
    }

    return await new Promise((rs, rj) => {
        _batchRequests.push({data, rs, rj});
    })
}

export function to_query(url, data) {
    var deparam = function parse_q(url) {
        if (url.indexOf("?") === -1)
            return {url: url, params: []};

        var params = [];
        var qs = url.substring(url.indexOf('?')+1).split("&");
        var url = url.substring(0, url.indexOf('?'));

        if (qs.length == 1 && qs[0].length == 0)
            qs = [];

        for (var i = 0; i<qs.length; i++) {
            params.push(qs[i]);
        }

        return {
            url: url,
            params: params
        }
    };
    var dispatch = function dispatch(parts, prefix, value) {
        if (["number", "string"].indexOf(typeof value) >= 0) {
            parts.push(prefix + "=" + encodeURIComponent("" + value));
        } else if (Array.isArray(value)) {
            o2a(parts, prefix, value);
        } else {
            o2o(parts, prefix, value);
        }
    };
    var o2a = function o2a(parts, prefix, value) {
        prefix = prefix + "[]";
        for (var i=0; i<value.length; i++) {
            dispatch(parts, prefix, value[i]);
        }
    };
    var o2o = function o2o(parts, prefix, value) {
        for (let key in value) {
            if (prefix.length > 0)
                key = "["+key+"]";

            dispatch(parts, prefix+key, value[key]);
        }
    };

    var dp = deparam(url);

    var parts = dp.params;
    url = dp.url;
    dispatch(parts, "", data);
    if (parts.length == 0)
        return url;
    return url + "?" + parts.join("&");
};


export async function resolve_url(data) {
    data = structuredClone(data);
    if (Organizer.organizer_id !== null && !data.organizer_id)
        data.organizer_id = Organizer.organizer_id;
    if (!data.locale) {
        data.locale = InBackend ? WebshopInfo.language.parent : WebshopInfo.language.tag;
    }
    if (!InBackend) data.__webshop = WebshopInfo.webshop;
    var query = to_query('/api/path/resolve', data)

    var cached =__tmcache("resolve_url?" + query)
    if (!!cached) return Promise.resolve(cached);

    let url = await performRequest(data);
    if (url === null) {
        throw new Error(`Failed to get URL for parameters: ${JSON.stringify(data)}`);
    }
    var keys = Object.keys(data);
    for (var i = 0; i<keys.length; i++) {
        var obj = data[keys[i]];
        if (typeof obj !== "string") continue;
        if (obj.indexOf(":") != 0) continue;
        obj = obj.replace(":", "%3A");
        url = url.replace(obj, data[keys[i]]);
    }

    var index = url.lastIndexOf("?");
    if (index != -1)
        url = url.substring(0, index);

    __tmcache.push("resolve_url?" + query, url);

    return url;
};
